export default class DateFormat {

	static formatDate(dicomDate: string): string | null {
		if (dicomDate.length === 8) {
			return `${dicomDate.slice(6, 8)}/${dicomDate.slice(4, 6)}/${dicomDate.slice(0, 4)}`;
		}
		return null;
	}
}